export type Id = string

export type TenantId = Id & { readonly __brand: 'TenantId' }
export type PipelineId = Id & { readonly __brand: 'PipelineId' }
export type ManagerId = Id & { readonly __brand: 'ManagerId' }
export type StatusId = Id & { readonly __brand: 'StatusId' }
export type LeadId = Id & { readonly __brand: 'LeadId' }
export type ContactId = Id & { readonly __brand: 'ContactId' }
export type TagId = Id & { readonly __brand: 'TagId' }
export type CrmId = Id & { readonly __brand: 'CrmId' }
export type CandidateId = Id & { readonly __brand: 'CandidateId' }
/** Identity node: a person or company as a set of identifiers (ADR-0005). */
export type CustomerId = Id & { readonly __brand: 'CustomerId' }
/** One commercial cycle: one customer × one intent to buy (ADR-0005). */
export type LudusLeadId = Id & { readonly __brand: 'LudusLeadId' }
/** One automation: a trigger, an optional condition, and one action (ADR-0007 §1). */
export type FlowId = Id & { readonly __brand: 'FlowId' }

export const asTenantId = (s: string): TenantId => s as TenantId
export const asPipelineId = (s: string): PipelineId => s as PipelineId
export const asManagerId = (s: string): ManagerId => s as ManagerId
export const asStatusId = (s: string): StatusId => s as StatusId
export const asLeadId = (s: string): LeadId => s as LeadId
export const asContactId = (s: string): ContactId => s as ContactId
export const asTagId = (s: string): TagId => s as TagId
export const asCrmId = (s: string): CrmId => s as CrmId
export const asCandidateId = (s: string): CandidateId => s as CandidateId
export const asCustomerId = (s: string): CustomerId => s as CustomerId
export const asLudusLeadId = (s: string): LudusLeadId => s as LudusLeadId
export const asFlowId = (s: string): FlowId => s as FlowId
